<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()


const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const handleNextStep = async () => {
  await handleNext('tutorial_moving_map')
}

const goToMap = () => {
  router.push('/map')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.exploration.movingMap.howToMove') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.exploration.movingMap.tryMovingDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="sm:hidden">
        {{ t('tutorial.exploration.movingMap.tryMovingMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">
        {{ t('common.actions.gotoMap') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.exploration.movingMap.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>